import styled from 'styled-components';

const FloatingPaletteBase = styled.div.attrs(props => ({
    left: props.left || 16,
    top: props.top || 16,
    zIndex: props.zIndex || 550,
}))`
    position:absolute;
    left:${props => `${props.left}px`};

    top:${props => props.bottom ? 'unset' : `${props.top}px`};
    bottom: ${props => props.bottom ? `${props.bottom}px` : 'unset'};

    z-index:${props => props.zIndex};
    display: flex;
    flex-direction: column;
    border:1px solid;
    border-radius:3px;
    transition: all 0.2s ease-in-out ;
    opacity: 0.8;
    &:hover {
        border-radius:4px;
        opacity: 1;
        transition: all 0.2s ease-in-out;
    }
`;

const FloatingPaletteClosed = styled(FloatingPaletteBase)`
    width:42px;
    transition: width 0.2s ease-in-out, height 0.2s ease-in-out;
    //&:hover {
    //    width: 160px;
    //}
`;

const FloatingPaletteOpen = styled(FloatingPaletteBase).attrs(props => ({
    width: props.width || 160
}))`
    width:${props => `${props.width}px`};
    transition-property: width, height;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;
    //border-radius:4px;
    opacity: 1;
`;

export {
    FloatingPaletteOpen,
    FloatingPaletteClosed,
    FloatingPaletteBase
};